module.exports = __webpack_public_path__ + "public/img/qqd_demo5.d4f231ba.png";